import Collection from '../../collection';
import Calendar from '../../collection/calendar';
import Filters from '../../view/module/schedule/launch.filters';
import Tasks from '../../collection/schedule/tasks';
import Module from '../../core/module';
import Schedule from '../../model/schedule';
import ScheduleCalendarModule from './calendar';
import ScheduleFormModule from './form';
import Stats from '../../collection/schedule/stats';
import ScheduleCalendar from './calendar';
import ScheduleTemplateModule from './templates.form';
import ScheduleTemplatesModule from './templates.list';
import TasksModule from '../tasks/list';

import { ask, } from '../../utils/popups';
import { fmt, datify, unixts, } from '../../utils/date';
import { del, } from '../../http/api';
import { beginLock, endLock } from '../../loader';





const 
    REPLACE = 'schedule-card--open-replace';





export default Module.extend( {

    initialize(options = {}) {
        Module.prototype.initialize.call( this, options );

        this.lastFiltering_ = Promise.resolve();
    },

    template: 'jst/module.schedule.tasks',

    url() {
        return this.options.time
            ? `schedule/${this.options.schedule.id}/tasks/${fmt( this.options.date, 'YYYY-MM-DD' )}/@/${this.options.time.replace( ':', '-' )}`
            : `schedule/${this.options.schedule.id}/tasks/${fmt( this.options.date, 'YYYY-MM-DD' )}`;
    },

    open({ scheduleId, time, month, date }) {
        return this.options.scheduleId = scheduleId,
            this.options.time = time,
            this.setState( { month: unixts( datify( month ) ), } ),
            this.options.date = date,
            this.options.tasks = new Tasks( [] ),
            this.options.calendar = new Calendar( this.state().month ),
            this.options.stats = new Collection(),
            this.filtersModel = new Filters.Model( this.state().filters ),
            this.lastFiltering_ = Promise.resolve(),
            this.postpone( fetchTasks, fetchCalendar )
                .then( () => this.bind( this.filtersModel ) );
        },

    start() {
        return this;
    },

    stop() {
        return this;
    },

    events: {

        'click .-toggle-list'() {
            this.trigger( ScheduleCalendarModule.TOGGLE_LIST_VIEW, 
                datify( this.state().month ),
                this.options.date,
                this.state().filters,
                this.options.schedule.id,
                this.options.time );
        },
            
        'click .-new-schedule': function({currentTarget}) {
            this.trigger( ScheduleFormModule.POPUP_NEW );
        },

        'click .-popup-schedule-template'({currentTarget}) {
            const { templateId } = currentTarget.dataset;
            this.trigger( ScheduleTemplateModule.POPUP_EDIT, 
                // pass id only to force Schedule.byId in Template form
                this.options.schedule.id,
                templateId,
                this.state().month ); // todo month?
        },

        'click .-remove-schedule-template'({currentTarget}) {
            const 
                { templateId } = currentTarget.dataset,
                { schedule } = this.options;

            const deletion = ask( 'schedule::modal delete template - confirmation text', 
                'schedule::modal delete template - title', 
                'actions::yes', 
                'actions::no',
                () => {
                    beginLock( this );
                    return new Schedule( { id: schedule.id, } )
                        .patch( { templates: {
                            remove: [{ id: +templateId }]
                        }, } );
                } );

            deletion.then( () => endLock( this ), () => endLock( this ) );

            return reRenderAfterDeletion.call( this, deletion );
        },

        'click .-toggle-monthly'() {
            this.trigger( ScheduleCalendarModule.TOGGLE_CALENDAR,
                // pass id only; schedule will be retrieved by /stats response
                this.options.schedule.id,
                this.options.time,
                this.state().month,
                this.options.date,
                this.state().filters );
        },

        'click .-open-task'(e) {
            const { taskId } = e.currentTarget.dataset;
            this.trigger( TasksModule.OPEN_TASK, +taskId );
            return e.stopPropagation(), undefined;
        },

    },

    [Module.event( ':schedule:edit' )]({ id }) {
        return this.trigger( ScheduleFormModule.POPUP_EDIT, 
            // pass id only to force Schedule.byId in Form
            id );
    },

    [Module.event( ':schedule:delete' )]({ id }) {
        const deletion = ask( 'schedule::modal delete schedule - confirmation text', 
            'schedule::modal delete schedule - title', 
            'actions::yes', 
            'actions::no',
            () => del( `/timetables/${id}` )
                .blocking( this ).cerebellum()
                .execute() );

        return reRenderAfterDeletion.call( this, deletion );
    },

    [Module.event( ':schedule:templates' )]({ id }) {
        return this.trigger( ScheduleTemplatesModule.POPUP, 
            // pass id only to force Schedule.byId in Template List
            id );
    },

    [Module.event( 'Filters:change' )](filters) {
        this.setState( { filters, page: 1, } );
        return this.postpone( fetchTasks, fetchCalendar )
            .then( () => Promise.all( [ this.Calendar.render(), this.Tasks.render(), this.Paging.render() ] ) )
            .then( () => this.navigated() );
    },

    [Module.event( 'Paging:page' )](page) {
        return this.setState( { page: +page, } ),
            beginLock( this ),
            this.postpone( fetchTasks )
                .then( () => this.Tasks.render() )
                .then( () => endLock( this ) )
                .then( () => this.navigated() );
    },

    [Module.event( 'Calendar:set-month' )](month) {
        return this.options.calendar.set( month ),
            this.setState( { month: unixts( this.options.calendar.getMonth() ) } ),
            this.postpone( fetchCalendar )
                .then( () => this.Calendar.render() )
                .then( () => this.navigated() );
    },

    [Module.event( 'Calendar:date:toggle' )](date) {
        return this.options.date = date,
            this.setState( { page: 1, } ),
            this.postpone( fetchTasks )
                .then( () => this.render() )
                .then( () => this.navigated() );
    },
        
    [Module.event( ':schedule:unpin' )]() {
        this.trigger( ScheduleCalendar.OPEN_LAUNCHES_DAILY, 
            this.state().month,
            this.options.date,
            this.state().filters );
    },

    [Module.event( ':time:toggle')](time) {
        this.options.time = time != this.options.time
            ? time
            : undefined;
        this.setState( { page: 1, } );
        beginLock( this );

        return this.postpone( fetchTasks, fetchCalendar )
            .then( () => this.render() )
            .then( () => this.navigated() )
            .then( () => endLock( this ), () => endLock( this ) );
    },

    postpone(...fetchFunctions) {
        return this.lastFiltering_ = this.lastFiltering_.then( 
            () => Promise.all( 
                fetchFunctions.map( fn => fn.call( this  ) ) ) );
    },

}, {

    REPLACE,

} );





function reRenderAfterDeletion(promise) {
    return promise
        .then( () => beginLock( this ) )
        .then( () => this.postpone( fetchTasks, fetchCalendar ) )
        .then( () => {
            if (this.options.tasks.total > 0 && !this.options.tasks.length)
                if (this.state().page > 1)
                    return this.setState( { page: this.state().page - 1, } ),
                        this.postpone( fetchTasks, fetchCalendar );
        } )
        .then( () => this.render() )
        .then( () => endLock( this ), () => endLock( this ) )
        .then( () => this.navigated() );
}

function fetchTasks() {
    const
        { scheduleId, time, date } = this.options,
        { page } = this.state();

    const filters = {
        date, time,
        limit: 12,
        page,
        timetableId: scheduleId,
        ...this.filtersModel.values()
    };

    return this.options.tasks.filter( filters )
        .then( ([items, coll, resp]) => {
            this.options.times = resp.times;
            this.options.schedule = resp.schedule;
        } );
}

function fetchCalendar() {
    const { scheduleId } = this.options;

    const filters = { 
        time: this.options.time,
        timetableId: scheduleId,
        ...this.filtersModel.values(),
    };
        
    const collection = new Stats( { calendar: this.options.calendar, } );
    return collection.filter( filters ).then( 
        ([items/*, coll*/]) => this.options.stats.reset( items ) );
}


// WEBPACK FOOTER //
// ./src/js/module/schedule/tasks.js